// 抖店相关接口
import api from '@/api/dd/common.js'
const state = {
	
}
const mutations = {
	
}
const actions = {
	ddXxxxxxAPI({ }, params = {}) {  // 范例
        return api.ddXxxxxxAPI(params)
    },
	getDdClassCateAPI({ }, params = {}) {
        return api.getDdClassCateAPI(params)
    },
    getDdClassCateTopAPI({ }, params = {}) {
        return api.getDdClassCateTopAPI(params)
    },
	getCatePropertiesAPI({ }, params = {}) {
        return api.getCatePropertiesAPI(params)
    },
	createEditDdGoodsAPI({ }, params = {}) {
        return api.createEditDdGoodsAPI(params)
    },
    getDdGoodsListAPI({ }, params = {}) {
        return api.getDdGoodsListAPI(params)
    },
    ddClassGroundingAPI({ }, params = {}) {
        return api.ddClassGroundingAPI(params)
    },
    getDdGoodsDetailAPI({ }, params = {}) {
        return api.getDdGoodsDetailAPI(params)
    },
    changeDdGoodsStockAPI({ }, params = {}) {
        return api.changeDdGoodsStockAPI(params)
    },
    getDdCanSelectClassListAPI({ }, params = {}) {
        return api.getDdCanSelectClassListAPI(params)
    },
    getDdRefundListAPI({ }, params = {}) {
        return api.getDdRefundListAPI(params)
    },
    cancelVerifyAPI({ }, params = {}) {
        return api.cancelVerifyAPI(params)
    },
}
export default {
	namespaced:true,
	state,
	mutations,
	actions,
}